<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="tableHeight - 100"
      border
      :edit-rules="validRules"
      @edit-closed="changeDate"
      show-footer
    >
      <template v-slot:top>
        <div class="d-flex mt-2 mb-2">
          <div class="title">
            {{ $l('form_label_cessation_date') || '停产日期' }}
          </div>
          <div>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
          </div>
          <el-button
            size="mini"
            @click="addNewsRow()"
            v-if="!disabled"
            style="border-radius: 4px !important;"
            >{{ $l('form_label_add_cessation_date') || '添加停产日期' }}
          </el-button>
          <el-button
            size="mini"
            v-if="!disabled"
            @click="addHoliday()"
            style="border-radius: 4px !important;"
            >{{ $l('form_label_batch_add_holiday') || '一键添加节假日' }}
          </el-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    productionEndDate: { type: String, default: '' },
    productionDate: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      formData: {},
    }
  },
  computed: {
    tableColumns() {
      return tableColumns(this)
    },
    validRules() {
      return {
        cessationDate: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('rules_select_cessationDate') || '请选择停产日期',
          },
          {
            validator: ({ row }) => {
              const { cessationDate, _X_ID } = row
              const tableData = this.getTableData().filter(
                (item) => item._X_ID !== _X_ID
              )
              if (tableData && tableData.length) {
                const data = tableData.filter(
                  (item) => item.cessationDate === cessationDate
                )
                if (data && data.length) {
                  return new Error(
                    this.$l('tips_table_rules_repeat_cessationDate')
                  )
                }
              }
            },
          },
        ],
      }
    },
  },
  mounted() {},
  methods: {
    loadData(data) {
      this.tableData = data
      this.$nextTick(() => {
        this.sortTable()
      })
    },
    async addNewsRow() {
      const $itemTable = this.$refs.itemTable
      const { row: newRow } = await $itemTable.insertAt({})
      await $itemTable.setActiveCell(newRow, 'cessationDate')
    },
    async delRow(row) {
      this.$refs.itemTable.remove(row)
      this.sortTable()
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    sortTable() {
      this.$refs.itemTable.sort('cessationDate', 'asc')
    },
    async validate() {
      const result = await this.$refs.itemTable.validate(true).catch(() => true)
      return !result
    },
    async changeDate() {
      this.sortTable()
    },
    async addHoliday() {
      if (!this.productionEndDate || !this.productionDate) {
        this.$message.warning(
          this.$l('message_pls_select_production_and_end_date') ||
            '请先选择计划投产日期、计划结束日期!'
        )
        return
      }
      if (this.loadingOpen()) return

      const res = await this.$api
        .evgPlanProductionHolidayApi({
          productionEndDate: this.productionEndDate,
          productionDate: this.productionDate,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      let cessationDateData = res.body || []
      const currData = this.getTableData()
      const currCessationDate = currData.map((k) => k.cessationDate)
      cessationDateData = cessationDateData
        .filter((e) => !currCessationDate.includes(e))
        .map((e) => {
          return {
            cessationDate: e,
          }
        })
      if (cessationDateData && cessationDateData.length) {
        this.$refs.itemTable.insertAt(cessationDateData)
        this.sortTable()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  color: #101010;
  font-weight: 600;
}
</style>
